<template>
  <v-container>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 md9 lg10 xs12 sm11>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="typeEstrategico == '1' ">
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <h4 class="pull">Indicador: Tasa Titulación</h4>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <v-layout>
                <v-flex md6 lg6 xs6 sm6 v-if="this.$session.getAll().ccData.esMayor == true">
                  <label class="left" for="sel1">Tus departamentos</label>
                  <select class="form-control" id="5" @change="cargaArchivos()" v-model="menor">
                    <option selected disabled>-Selecciona una opción-</option>
                    <option
                      v-for="(menor,index) in listMenores"
                      :key="index"
                      :value="menor"
                    >{{menor.ccNombre}}</option>
                  </select>
                </v-flex>
                <v-flex
                  md6
                  lg6
                  xs6
                  sm6
                  v-if="firstTime == true || this.$session.getAll().ccData.esMayor == false"
                >
                  <label class="left" for="sel1">Tus carreras</label>
                  <select class="form-control" id="5" @change="cambiarCarrera()" v-model="carrera">
                    <option selected disabled>-Selecciona una opción-</option>
                    <option
                      v-for="(carrera,index) in carreras"
                      :key="index"
                      :value="carrera"
                    >{{carrera.nombre}}</option>
                  </select>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <br />
          <v-layout v-show="first">
            <v-flex md10 lg10 xs12 sm12 id="chartdiv"></v-flex>
            <v-flex md1.5 lg xs0 sm0 hidden-sm-and-down>
              <v-navigation-drawer floating permanent stateless class="drawner" value="true">
                <v-list dense>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title class="v-list-new">
                        <v-btn
                          small
                          color="#EB7704"
                          class="button"
                          :to="{name:'indicador'}"
                        >Tasa titulación</v-btn>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title class="v-list-new">
                        <v-btn
                          small
                          color="#EB7704"
                          class="button"
                          :to="{name:'retencion'}"
                        >Retención</v-btn>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title class="v-list-new">
                        <v-btn
                          small
                          color="#EB7704"
                          class="button"
                          href= "http://sie.usach.cl/"
                          target = "_blank"
                        >SIE</v-btn>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-navigation-drawer>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import img1 from "../../assets/Captura2.png";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);
export default {
  data() {
    return {
      firstTime: false,
      ccfacu: "",
      facu: "Facultad u otros",
      depa: "",
      cotaSuperior: "",
      isMayor: false,
      menor: "",
      carreras: "",
      carrera: "",
      listMenores: "",
      datachartfacultad: "",
      datachart: [
        {
          anho: "2016",
          valor: "25"
        },
        {
          anho: "2017",
          valor: "28"
        },
        {
          anho: "2018",
          valor: "24"
        },
        {
          anho: "2019",
          valor: "16"
        }
      ],
      first: true,
      create: false,
      edit: false,
      index: "",
      dialog: false,
      objetivoSelected: 1,
      objetivo: {
        nombre: "",
        propuestaObjetivo: ""
      },

      misionPropuesta:
        "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word, Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word",

      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      filesDge: "",
      img1: img1,
      right: null
    };
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    carrera: function() {
      //console.log("cambia datachart");
      this.chart();
    },
    facu: function() {
      //console.log("cambia facu");
      this.chart();
    }
  },

  mounted() {},

  created() {
    this.objetivo = 0;
    //ESTE AXIOS ES CUANDO ES FACULTAD y LLAMA GUARDA TODO LOS MENORES
    if (this.$session.getAll().ccData.esMayor == true) {
      this.facu = this.$session.getAll().ccData.ccNombre;
      //console.log(this.$session.getAll().ccData.ccNombre);
      if (this.$session.getAll().ccData.ccValor == 95) {
        this.firstTime= true;
        //console.log("soy quimica y farmacia");
        const array = [];
        array.push(this.$session.getAll().ccData)
        this.listMenores = array;
        //console.log(this.listMenores)
        this.menor = this.listMenores[0];
        this.depa = this.menor;
        //this.carreras = this.menor.tasaTitulacion;
        //this.carrera = this.carreras[0];
        this.isMayor = true;
        axios
          .get(
            process.env.ROOT_API +
              "/indicador/getByCc?cc=" +
              this.$session.getAll().ccData.ccValor,
            this.auth
          )
          .then(response => {
            //console.log(response.data);
            this.datachartfacultad = response.data.tasaTitulacion;
            //console.log(this.datachart);
            this.agregaFacultad();
          })
          .catch(error => {
            console.error(error);
          })

          .then(response => {
            this.chart();
          }).then(response => {
            this.getDataChart(this.menor.ccValor);
          })
      } else {
        axios
          .get(
            process.env.ROOT_API +
              "/centrocosto/getMenoresByccMayor?cc=" +
              this.$session.getAll().ccData.ccValor,
            this.auth
          )
          .then(response => {
            this.listMenores = response.data;
            //console.log(this.listMenores)
            this.menor = this.listMenores[0];
            this.depa = this.menor;

            //this.carreras = this.menor.tasaTitulacion;
            //this.carrera = this.carreras[0];
            this.isMayor = true;
            //console.log(this.listMenores);
          })
          .catch(error => {
            console.error(error);
          })
          .then(response => {
            axios
              .get(
                process.env.ROOT_API +
                  "/indicador/getByCc?cc=" +
                  this.menor.ccValor,
                this.auth
              )
              .then(response => {
                //console.log(response.data);
                this.datachart = response.data.tasaTitulacion;
                //console.log(this.datachart);
              })
              .catch(error => {
                console.error(error);
              })
              .then(response => {
                axios
                  .get(
                    process.env.ROOT_API +
                      "/indicador/getByCc?cc=" +
                      this.$session.getAll().ccData.ccValor,
                    this.auth
                  )
                  .then(response => {
                    //console.log(response.data);
                    this.datachartfacultad = response.data.tasaTitulacion;
                    //console.log(this.datachart);
                    this.agregaFacultad();
                  })
                  .catch(error => {
                    console.error(error);
                  })

                  .then(response => {
                    this.chart();
                  });
              });
          });
      }
    } else {
      axios
        .get(
          process.env.ROOT_API +
            "/centrocosto/getIndicador?ccMenor=" +
            this.$session.getAll().ccData.ccValor,
          this.auth
        )
        .then(response => {
          this.ccfacu = response.data.centroCosto;
          //console.log("aqui esta la facultad");
          //console.log(response.data);
          this.datachartfacultad = response.data.tasaTitulacion;
        })
        .catch(error => {
          console.error(error);
        })
        .then(response => {
          axios
            .get(
              process.env.ROOT_API +
                "/centrocosto/getByCcValor?ccValor=" +
                this.ccfacu,
              this.auth
            )
            .then(response => {
              //console.log(response.data.ccNombre);
              this.facu = response.data.ccNombre;
            })
            .catch(error => {
              console.error(error);
            });
        })
        .catch(error => {
          console.error(error);
        })

        .then(response => {
          axios
            .get(
              process.env.ROOT_API +
                "/indicador/getByCc?cc=" +
                this.$session.getAll().ccData.ccValor,
              this.auth
            )
            .then(response => {
              //console.log(this.$session.getAll().ccData);
              this.carreras = response.data.carreras;
              this.carrera = this.carreras[0];
              this.depa = this.$session.getAll().ccData;
              this.menor = response.data.tasaTitulacion;
              this.datachart = response.data.tasaTitulacion;
              //console.log(this.datachart);
            })
            .catch(error => {
              console.error(error);
            })
            .then(response => {
              this.cambiarCarrera();
            })
            .then(response => {
              this.chart();
            });
        });
    }
  },

  methods: {
    chart() {
      let chart = am4core.create("chartdiv", am4charts.XYChart);
      chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.dataFields.category = "anho";
      categoryAxis.renderer.minGridDistance = 40;
      categoryAxis.fontSize = 11;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      valueAxis.max = 100;
      valueAxis.strictMinMax = true;
      valueAxis.renderer.minGridDistance = 30;

      /*
// this is exactly the same, but with events
axisBreak.events.on("over", function() {
  axisBreak.animate(
    [{ property: "breakSize", to: 1 }, { property: "opacity", to: 0.1 }],
    1500,
    am4core.ease.sinOut
  );
});
axisBreak.events.on("out", function() {
  axisBreak.animate(
    [{ property: "breakSize", to: 0.005 }, { property: "opacity", to: 1 }],
    1000,
    am4core.ease.quadOut
  );
});*/

      var series1 = chart.series.push(new am4charts.ColumnSeries());
      series1.dataFields.categoryX = "anho";
      series1.dataFields.valueY = "valor2";
      series1.columns.template.tooltipText = " {valueY.value}%";
      series1.columns.template.tooltipY = 0;
      series1.columns.template.strokeOpacity = 0;
      series1.name = this.facu;
      chart.data = this.datachart;
      // probar con un if mañana
      if (this.menor.esMayor != true) {
        var series2 = chart.series.push(new am4charts.ColumnSeries());
        series2.dataFields.categoryX = "anho";
        series2.dataFields.valueY = "valor";
        series2.columns.template.tooltipText = " {valueY.value}%";
        series2.columns.template.tooltipY = 0;
        series2.columns.template.strokeOpacity = 0;
        series2.name = this.depa.ccNombre;
        series2.fill = am4core.color("#b1b1b1");
      }

      if (this.carrera != "") {
        var series3 = chart.series.push(new am4charts.ColumnSeries());
        series3.dataFields.categoryX = "anho";
        series3.dataFields.valueY = "valor3";
        series3.columns.template.tooltipText = " {valueY.value}%";
        series3.columns.template.tooltipY = 0;
        series3.columns.template.strokeOpacity = 0;
        series3.name = this.carrera.nombre;
        series3.fill = am4core.color("#394049");
      }
      // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
      series1.fill = am4core.color("#ec6a12");

      chart.legend = new am4charts.Legend();
    },

    redirect(index) {
      this.typeEstrategico = index;
    },

    cargaArchivos() {
      //console.log("Cambiando de departamento " + this.menor.ccValor);
      this.firstTime = true;
      this.depa = this.menor;
      this.carrera = "";
      this.getDataChart(this.menor.ccValor);
    },

    cambiarCarrera() {
      //console.log("Cambiando de carrera " + this.carrera.nombre);
      this.agregaFacultad();
    },

    sacaMaximo(arreglo) {
      var valores = [];
      arreglo.map(function(x) {
        valores.push(x.valor);
      });
      var max = Math.max.apply(null, valores);
      return max + 3;
    },

    agregaFacultad() {
      //console.log("agregando los valores de facultad");
      //console.log(this.datachartfacultad);
      var newdata = this.datachart;
      var i = 0;
      while (i < 4) {
        newdata[i]["valor2"] = this.datachartfacultad[i].valor;
        if (this.carrera != "") {
          newdata[i]["valor3"] = this.carrera.tasaTitulacion[i].valor;
        }
        i++;
      }
      //console.log("finally");
      //console.log(newdata);
      this.datachart = newdata;
    },

    getDataChart(cc) {
      axios
        .get(process.env.ROOT_API + "/indicador/getByCc?cc=" + cc, this.auth)
        .then(response => {
          this.datachart = response.data.tasaTitulacion;
          this.carreras = response.data.carreras;
          //console.log(this.carreras);
        })
        .catch(error => {
          console.error(error);
        })
        .then(response => this.agregaFacultad())
        .then(response => {
          this.chart();
        });
    },

    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDge.dge[index]["path"]);
      var nameFile = this.filesDge.dge[index]["name"];
      //console.log(nameFile);
      axios
        .get(
          process.env.ROOT_API +
            "/uploadFileDcaEtc/downloadFile?dir=" +
            pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    updateOtros(propuesta) {
      this.dialog = false;
    },

    openEditObservaciones() {
      this.create = false;
      this.edit = true;
    },

    opencreateObjetivo() {
      this.create = true;
      this.edit = true;
      this.objetivo = {
        nombre: "",
        propuestaObjetivo: ""
      };
    },

    editObservacion(objetivo) {
      //console.log(objetivo);
      this.objetivos[objetivo] = objetivo;
      this.edit = false;
    },

    createObjetivo() {
      //console.log(this.objetivo.queHaremos);
      this.objetivos.push(this.objetivo);
      this.edit = false;
    },

    replaceT(texto) {
      var newTexto = texto.replace(/\n/g, "<br />");
      //console.log(newTexto);
      return newTexto;
    }
  }
};
</script>


<style scoped>
#chartdiv2 {
  width: 100% !important;
  height: 300px !important;
}

.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 12px;
}

.table2 {
  height: 50px !important;
}

.v-card-new {
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #fafafa;
  height: 400px !important;
  overflow-y: auto;
}

.v-card {
  height: 350px;
  overflow-y: auto;
}

.td-color {
  background: #394049;
  height: 100%;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.header-fixed {
  width: 100%;
}
.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}
.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 200px;
  width: 100%;
}

.header-fixed > tbody > tr > td,
.header-fixed > thead > tr > th {
  float: left;
  font-size: 11px;
}

.th {
  background-color: aqua !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

#chartdiv {
  width: 100%;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/diagnosticoEstrategico/Indicadores.vue